import type { ArmyPaint } from '../../../lib/core/ArmyPainter/ArmyPaint.type'
import { armyPaintDisk } from '../../../lib/core/disk/IndexedDBDisk'
import {
  EXPORT_DISK_PLACEHOLDER_ERROR,
  StateMapDisk,
  WORKSPACE_DISK_PLACEHOLDER_ERROR,
} from '../../../lib/core/state/state_map_disk.enum'
import { backendAxios } from '../../../axios'
import { getAuthArmyPaint, setAuthArmyPaint } from './AuthArmyPaintSignal'
import { hasIndexedDB } from '../../../lib/core/Storage/IndexedDB/hasIndexedDB'

export default async function deleteArmyPaintToDisk(ap: ArmyPaint) {
  if (ap.disk === StateMapDisk.IndexedDB) {
    if (!hasIndexedDB()) {
      throw new Error('IndexedDB requested but not available')
    }
    await armyPaintDisk.delete(ap.id)
  } else if (ap.disk === StateMapDisk.Cloud) {
    await backendAxios.delete(`/st1/army-paint/${ap.id}`)
  } else if (ap.disk === StateMapDisk.Export) {
    throw new Error(EXPORT_DISK_PLACEHOLDER_ERROR)
  } else if (ap.disk === StateMapDisk.Workspace) {
    throw new Error(WORKSPACE_DISK_PLACEHOLDER_ERROR)
  } else {
    throw new Error('Invalid disk: ' + ap.disk)
  }

  // Remove from selected if it's the one being deleted
  if (getAuthArmyPaint()?.id === ap.id) {
    setAuthArmyPaint(null)
  }
}
